import { createContext } from 'react';
import { ListSidebarContextProps } from './types';

export const listSidebarPortalClass = 'sidebar-portal';
export const listSidebarPortalExpandedClass = 'sidebar-portal--expanded';
export const ListSidebarContext = createContext<null | ListSidebarContextProps>(null);
export const DEFAULT_VISIBILITY_STATE = true;
export const LIST_SIDEBAR_FILTER_FORM_NAME = 'LIST_SIDEBAR_FILTER_FORM';
